import React from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
  useLocation,
} from "react-router-dom";

import { Authenticator } from "@aws-amplify/ui-react";
import { useCognitoGroup } from "./hooks/useCognitoGroup";

import Protected from "./components/Protected";
// import Login from "./components/LoginBasic";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Students from "./containers/Students";
import Student from "./containers/Student";

import Majors from "./containers/Majors";
import CreateMajor from "./containers/CreateMajor";
// import Settings from "./containers/Settings";
import Export from "./containers/Export";
import Dashboard from "./containers/Dashboard";

// import AuthProvider from "./context/authBasic";
import StudentsProvider from "./context/students";
import { DashboardProvider } from "./context/dashboard";
import LangProvider from "./context/lang";
import MajorsProvider from "./context/majors";
import ModalProvider from "./context/modal";
import SearchProvider from "./context/search";
import SidebarProvider from "./context/sidebar";

import translation from "./config/translation";
import "@aws-amplify/ui-react/styles.css";
import "./styles/app.css";
import "./styles/sidebar.css";
import "./styles/login.css";

const AppLayout = () => {
  const { pathname } = useLocation();
  const { isMeritoGroup } = useCognitoGroup();
  const isDashboard = pathname === "/dashboard";
  const defaultPath = isMeritoGroup ? "/dashboard" : "/students";

  return (
    <div className="d-flex flex-column-mobile">
      <Menu />
      <div
        id="app-body"
        className={
          isDashboard
            ? "app-body-dashboard overflow-y-auto"
            : "width-content mx-auto px-10 px-sm-5 overflow-y-scroll"
        }
      >
        {!isDashboard && <Header />}
        <Route
          path="/"
          exact
          render={() => <Redirect to={defaultPath} />}
        />
        {!isMeritoGroup && (
          <>
            <Route path="/students/:id" component={Student} />
            <Route exact path="/students" component={Students} />
            <Route exact path="/majors" component={Majors} />
            <Route exact path="/createMajor" component={CreateMajor} />
            <Route exact path="/editMajor" component={CreateMajor} />
            {/* <Route exact path="/settings" component={Settings} /> */}
            <Route exact path="/export" component={Export} />
          </>
        )}
        <Route exact path="/dashboard" component={Dashboard} />
      </div>
    </div>
  );
};

export default () => {
  return (
    <Router>
      <Authenticator.Provider>
        <LangProvider translation={translation}>
          <ModalProvider>
            {/* <AuthProvider> */}
            <Protected>
              <DashboardProvider>
                <SearchProvider>
                  <StudentsProvider>
                    <MajorsProvider>
                      <SidebarProvider>
                        <Switch>
                          <AppLayout />
                        </Switch>
                      </SidebarProvider>
                    </MajorsProvider>
                  </StudentsProvider>
                </SearchProvider>
              </DashboardProvider>
            </Protected>

            {/* </AuthProvider> */}
          </ModalProvider>
        </LangProvider>
      </Authenticator.Provider>
    </Router>
  );
};
